// eslint-disable-next-line no-unused-vars
export default function cast<T>(value: any, describer?: T): T {
  return value as T;
}
